import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CartItemType } from "../../../../../../../api/src/cart/project-cart-item.entity";
import { TaskStatus } from "../../../../../../../api/src/encode/encode-task.entity";
import { getExportTypeTranslations } from "../../../../_core/services/localization.service";
import { DownloadItemEvent } from "../export-download-group-row/export-download-group-row.component";
import { ExportDownloadUtils } from "../export-download.utils";
import { ExportType } from "../../../../../../../api/src/encode/models/job-def.dto";

@Component({
  selector: 'app-export-download-item-row',
  templateUrl: './export-download-item-row.component.html',
  styleUrl: './export-download-item-row.component.scss'
})
export class ExportDownloadItemRowComponent {
	protected readonly CartItemType = CartItemType;
	protected readonly TaskStatus = TaskStatus;
	protected readonly ExportDownloadUtils = ExportDownloadUtils;
	readonly EXPORT_TYPE_LABELS  = getExportTypeTranslations();

	@Input() item: any;

	@Output() downloadItem: EventEmitter<DownloadItemEvent> = new EventEmitter<DownloadItemEvent>();
	@Output() retryTasks: EventEmitter<void> = new EventEmitter<void>();

	constructor() {}

	getItemFormats(item: any) {
		return item.encodeTasks.map(task => task.metadata.formats).flat();
	}

	getItemTaskFromFormat(item: any, format: ExportType) {
		return item.encodeTasks.find(task => task.metadata.formats.includes(format));
	}

}
